/**
 * Central Font Awesome icon registry.
 *
 * Per-icon imports keep the bundle lean — every icon below ships only when
 * a call-site references it. Disabling auto-CSS injection prevents FA's
 * runtime from poking the document head (we control sizing inline per
 * wrapper component).
 *
 * **Side effect**: `config.autoAddCss = false` must run before any
 * FontAwesomeIcon render. `src/main.tsx` imports this module once at app
 * entry to lock that ordering — do not rely on icon-consumer imports to
 * happen first.
 */
import { config } from "@fortawesome/fontawesome-svg-core";
import { faFacebookF, faInstagram, faLine, faTiktok } from "@fortawesome/free-brands-svg-icons";
import { faCube } from "@fortawesome/free-solid-svg-icons";

config.autoAddCss = false;

export const Icons = {
  // Brand mark
  brandMark: faCube,
  // Social platforms
  line: faLine,
  facebook: faFacebookF,
  instagram: faInstagram,
  tiktok: faTiktok,
} as const;

export type SocialIconKey = "line" | "facebook" | "instagram" | "tiktok";
